import { Option } from 'shared/components/Select/models/Option';
import { estateTypeMapLabel } from 'shared/constants/filters/advanced/estateType';
import { EEstateType } from 'shared/types/filters/advanced/estateType';

export const estateTypeOptions = [
  new Option(EEstateType.Rent, estateTypeMapLabel[EEstateType.Rent]),
  new Option(EEstateType.Owned, estateTypeMapLabel[EEstateType.Owned]),
];
